module.exports = __webpack_public_path__ + "media/hero-vid.ba174f89.mp4";